import ReviewSection from './ReviewSection';

const reviews = [
  { initials:'AT', bg:'linear-gradient(135deg,#4285F4,#1A73E8)', name:'Alex Thompson', role:'CEO, TechStart USA', quote:'"KodersPedia built our entire SaaS platform — authentication, dashboard, mobile app, and API — in under 6 months. Communication was impeccable. Truly world-class partners."', tags:['SaaS','Mobile App','API'], score:'5.0' },
  { initials:'SM', bg:'linear-gradient(135deg,#34A853,#0D7A3A)', name:'Sarah Mitchell', role:'Founder, GreenLeaf Co.', quote:'"Shopify rebuild increased our sales by 40% in the very first month. Professional, fast, and results-driven from day one to launch."', tags:['E-Commerce','Shopify'], score:'5.0' },
  { initials:'RK', bg:'linear-gradient(135deg,#7C3AED,#5B21B6)', name:'Raj Kumar', role:'CTO, FinanceFlow', quote:'"We engaged a project manager and full-stack developer from KodersPedia on a staff augmentation arrangement. We appreciate their proactive attitude and high-quality code."', tags:['Staff Aug','FinTech'], score:'5.0' },
  { initials:'JW', bg:'linear-gradient(135deg,#EA4335,#C62828)', name:'James Wilson', role:'VP Engineering, LogiTech', quote:'"World-class engineering with the Flutter-based dashboard. High-end interface and zero issues."', tags:['Flutter','IoT','Real-time'], score:'5.0' },
];

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" style={{width:12,height:12}}>
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

export default function GoogleSection() {
  return (
    <ReviewSection id="google">
      <div className="rs-label-row reveal-fade">
        <span className="rs-num">01</span>
        <span className="rs-platform-label">[ GOOGLE REVIEWS ]</span>
        <span className="rs-score">4.9 / 5.0</span>
      </div>
      <div className="rs-giant-wrap">
        <div className="rs-giant reveal-clip" aria-hidden="true">GOOGLE</div>
        <div className="rs-giant-meta reveal-fade">
          <div className="rs-stars-big">★★★★★</div>
          <div className="rs-count">200+ Verified Reviews</div>
        </div>
        <h2 className="rs-heading reveal-fade">KodersPedia Google Reviews</h2>
        <p className="rs-subheading reveal-fade">Rated 4.9 out of 5 based on 200+ verified reviews</p>
      </div>
      <div className="rs-list">
        {reviews.map((r, i) => (
          <div key={i} className="rs-item reveal-up">
            <div className="rs-item-left">
              <div className="rs-av" style={{ background: r.bg }}>{r.initials}</div>
              <div>
                <div className="rs-name">{r.name}</div>
                <div className="rs-role">{r.role}</div>
              </div>
            </div>
            <div className="rs-item-center">
              <div className="rs-quote">{r.quote}</div>
              <div className="rs-tags">{r.tags.map(t => <span key={t} className="rs-tag">{t}</span>)}</div>
            </div>
            <div className="rs-item-right">
              <span className="rs-stars-sm">★★★★★</span>
              <span className="rs-score-sm">{r.score}</span>
            </div>
          </div>
        ))}
      </div>

      <div style={{maxWidth:1300,margin:'40px auto 0',textAlign:'center'}}>
        <a href="https://www.google.com/search?sca_esv=4ae5e3414be49368&sxsrf=APpeQntshN2G6krJmkUiD-_5-boTuur3Gw:1785358301618&si=APenkKm7iecQ4G6P-TsbSMFKIQtv3EFIqRAFw-i8uEbk55Z-_wOGvn77ICSxCN17TxtbNcfYgQrWpkefFBjt81UTDD0PbyFEcmsJ3prHa9IPxpP9Nqj__KRZ33niwBKFh8vCk8JfJQXllyB8fMNDzpGZjKml8MRI7dtZhtzB_1-BjS55TOJTG_ek93tolxaW_aadqBfMR1Km&q=Koderspedia+-+Mobile+App+Development+Company+California+Reviews&sa=X&ved=2ahUKEwiojPX64fiVAxXL9bsIHX3gOGoQ0bkNegQIOxAH" target="_blank" rel="noopener noreferrer" style={{display:'inline-flex',alignItems:'center',gap:8,background:'rgb(27 31 94)',border:'1px solid rgb(27 31 94)',color:'#fff',fontSize:13,fontWeight:600,padding:'12px 28px',borderRadius:100,textDecoration:'none',letterSpacing:'.03em'}}>
          Read All Reviews on Google →
        </a>
      </div>
    </ReviewSection>
  );
}
